import { AssignedWireType } from '@/types/wireTypes';
import { authApiService } from '../../authApiService';
import { ApiResponseType } from '@/types/sharedTypes';

export const getRecipientWireApi = (wireId: string): Promise<ApiResponseType<AssignedWireType>> => {
  const uri = `/recipient/wires/${wireId}/`;

  return authApiService.GET(uri);
};
